import { hasAccessToRoute } from '~/src/config/protected-routes';

export default defineNuxtRouteMiddleware((to) => {
  const { data: session } = useAuth();
  const userStore = useUserStore();

  // Prefer live session role; fall back to persisted store role (handles session loading state)
  const raw = session.value as any;
  const sessionRole = raw?.result?.role?.role_code ?? raw?.role?.role_code ?? raw?.role ?? null;
  const role = (sessionRole as 'doctor' | 'clinic_doctor' | null) ?? userStore.role ?? null;

  if (!hasAccessToRoute(to.path, role)) {
    console.warn(`[role-guard] Access denied: role="${role}" tried to access "${to.path}"`);
    return navigateTo('/');
  }
});
